import { css } from 'linaria';
import { Variables, SwitchProps } from '../index';

export const theme = css`
    :global() {
        [data-theme='light'] {
            --switch-background-color: ${Variables.css.grey3};
        }

        [data-theme='dark'] {
            --switch-background-color: ${Variables.css.grey4};
        }
    }
`;

export const root = css`
    display: inline-flex;
    align-items: center;
    gap: ${Variables.css.spacing12};
    isolation: isolate;
`;

export const label = css``;

export const switchElement = css`
    position: relative;
    overflow: hidden;
    transition: background 0.2s cubic-bezier(0.22, 0.61, 0.36, 1), box-shadow 0.2s ease-in;
    appearance: none;
    border: 0;
    border-radius: 50px;
    background: var(--switch-background-color);

    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: var(--switch-height);
        height: var(--switch-height);
        background: ${Variables.css.catapultWhite};
        border-radius: 50%;
        border: 2px solid rgba(0, 0, 0, 0.2);
        background-clip: content-box;
        transition: transform 0.2s cubic-bezier(0.22, 0.61, 0.36, 1);
        transform: translateX(0);
        z-index: 1;
    }

    &:focus-visible {
        outline: none;
        box-shadow: 0 0 0 4px ${Variables.css.focusRing};
    }

    &[disabled],
    &[disabled] + .${label} {
        opacity: 0.5;
    }

    &[aria-checked='true'] {
        --switch-background-color: ${Variables.css.catapultOrange};

        &::before {
            transform: translateX(100%);
        }
    }
`;

export const sizes: Record<SwitchProps['size'], string> = {
    small: css`
        width: 40px;
        --switch-height: 20px;
        height: var(--switch-height);
    `,
    medium: css`
        width: 56px;
        --switch-height: 28px;
        height: var(--switch-height);
    `,
};
